/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2025, Zumper
 * @description  Reducer for contentModuleAmenities module
 */

import { falseReducer, payloadReducer, trueReducer } from '@zcode/reducers'
import type { CurrentSearch } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleAction, handleActions } from 'redux-actions'
import type * as actions from '../actions'
import {
  DONE_FETCHING_CONTENT_MODULE_AMENITIES,
  ERROR_FETCHING_CONTENT_MODULE_AMENITIES,
  RECEIVE_CONTENT_MODULE_AMENITIES,
  START_FETCHING_CONTENT_MODULE_AMENITIES,
} from '../constants'

type Actions = ExtractActions<Values<typeof actions>>

export const contentModuleAmenitiesAllowedList = [
  DONE_FETCHING_CONTENT_MODULE_AMENITIES,
  ERROR_FETCHING_CONTENT_MODULE_AMENITIES,
  RECEIVE_CONTENT_MODULE_AMENITIES,
  START_FETCHING_CONTENT_MODULE_AMENITIES,
] as const satisfies ReadonlyArray<Actions['type']>

declare const shouldBeEmpty: Exclude<
  Actions['type'],
  (typeof contentModuleAmenitiesAllowedList)[number]
>
false && (shouldBeEmpty satisfies never)

export const contentModuleAmenitiesReducer = combineReducers<
  CurrentSearch['contentModuleAmenities'],
  Actions
>({
  fetching: handleActions(
    {
      [START_FETCHING_CONTENT_MODULE_AMENITIES]: trueReducer,
      [DONE_FETCHING_CONTENT_MODULE_AMENITIES]: falseReducer,
      [ERROR_FETCHING_CONTENT_MODULE_AMENITIES]: falseReducer,
    },
    false
  ),
  data: handleAction<
    CurrentSearch['contentModuleAmenities']['data'],
    Actions,
    typeof RECEIVE_CONTENT_MODULE_AMENITIES
  >(RECEIVE_CONTENT_MODULE_AMENITIES, payloadReducer, null),
})
